import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { UpdatesSubtab } from '../../components/RegulatoryWatchAdmin';

export const AdminUpdatesPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <UpdatesSubtab />
    </FlexCol>
  );
};
